import React from "react"

function IconUserCheckmark({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="user-checkmark"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-user-checkmark"
      {...props}
    >
      <path
        d="M11.983 2.182c.873 0 1.693.22 2.406.604a2.188 2.188 0 0 0-.261 1.378 3.706 3.706 0 0 0-2.145-.673c-1.953 0-3.536 1.473-3.643 3.313l-.005.198v2.905c0 1.864 1.515 3.402 3.414 3.506l.205.006.203-.005c1.878-.084 3.365-1.529 3.469-3.308l.005-.199V7.002c0-.16-.01-.319-.033-.474l.774 1 .11.132c.138.152.292.28.458.383v1.864c0 1.29-.52 2.461-1.369 3.326l2.486.713a2.182 2.182 0 0 1 1.58 2.097v3.266a2.182 2.182 0 0 1-2.182 2.182H6.545a2.182 2.182 0 0 1-2.181-2.182v-3.26c0-.976.647-1.833 1.585-2.1l2.462-.7a4.735 4.735 0 0 1-1.386-3.342V7.002c0-2.662 2.22-4.82 4.958-4.82zm2.242 12.026c-.608.3-1.288.482-2.009.514l-.233.005a5.053 5.053 0 0 1-2.209-.503l-3.467.985a.873.873 0 0 0-.627.724l-.007.115v3.261c0 .445.333.812.763.866l.11.007h10.909a.873.873 0 0 0 .865-.763l.007-.11v-3.266a.873.873 0 0 0-.511-.794l-.12-.044-3.471-.997zm8.751-13.155a.655.655 0 0 1 .097.833L23 1.978l-4.43 4.664a.655.655 0 0 1-.919.03l-.072-.08-1.808-2.331a.655.655 0 0 1 .963-.88l.072.078 1.34 1.728 3.905-4.11a.655.655 0 0 1 .925-.024z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconUserCheckmark
